// extracted by mini-css-extract-plugin
export default {"description":"style_description__a5h6g","fade-in":"style_fade-in__4w-Lm","top":"style_top__q1Dtf","image":"style_image__fYSXi"};